/** @jsx jsx */
import { jsx } from '@emotion/core'
import { GuideBtnStyle } from '@views/Matchup/MatchField/MatchTab/index.style'
import GuideMatchBtnImg from '@assets/images/btn/guide-match-btn.png'
import GuideSiderBtnImg from '@assets/images/btn/guide-sider-btn.png'
import { Button } from '@styles/button.style'
import useRootStore from '@store/useRootStore'
import { isMobile } from 'react-device-detect'
import StorageUtils from '@utils/storage-utils'
import { LOCALSTORAGE_KEYS } from '@constants/index'
import { Fragment, useState } from 'react'
import { GlobalStoreKey } from '@v2/constants/common'
import dayjs from 'dayjs'
import _ from 'lodash'
import classNames from 'classnames'

function BeginnersGuideButton() {
  const { globalStore, userStore, authStore } = useRootStore()
  const [visible, setVisible] = useState(true)

  if (!visible) {
    return <Fragment/>
  }

  if (!authStore.isSignedIn) {
    return <Fragment/>
  }

  const enabled = globalStore.findGlobalSetting(GlobalStoreKey.TUTORIAL_VIDEO_POPUP_BUTTON_DISPLAY_ENABLED)?.value === '1' ?? false
  if (!enabled) {
    return <Fragment/>
  }

  const alreadyShowed = StorageUtils.getFromLocal(LOCALSTORAGE_KEYS.ADV_SHOW_TUTORIAL_VIDEO)
  if (alreadyShowed != null || alreadyShowed === '1') {
    return <Fragment/>
  }

  const { firstJoinAtByCivalue } = userStore
  const displayDay = globalStore.findGlobalSetting(GlobalStoreKey.TUTORIAL_VIDEO_POPUP_BUTTON_DISPLAY_DAY)?.value ?? 5
  const displayableDate = dayjs(firstJoinAtByCivalue).add(_.toNumber(displayDay), 'day').toDate()
  if (new Date() > displayableDate) {
    return <Fragment/>
  }

  const onClickTutorialVideoPopup = () => {
    StorageUtils.saveToLocal(LOCALSTORAGE_KEYS.ADV_SHOW_TUTORIAL_VIDEO, '1')
    setVisible(false)
    globalStore.setVisibleTutorialVideoPopup(true)
  }

  const className = classNames({
    'pc': !isMobile,
  })

  return (
    <Button TP css={GuideBtnStyle} onClick={onClickTutorialVideoPopup} className={className}>
      <img src={isMobile ? GuideSiderBtnImg : GuideMatchBtnImg} alt={isMobile ? '초보자 가이드 영상 버튼 1' : '초보자 가이드 영상 버튼 2'}/>
    </Button>
  )
}

export default BeginnersGuideButton
